module.exports = __webpack_public_path__ + "img/en.02c0fb94.svg";